// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Paa-z","fadeIn":"Qaa-z","delay":"Raa-z","recommendedSizeTooltip":"Saa-z"};